import { useState } from "react";
import { Ruler } from "lucide-react";
import { useIngredientUnits } from "../../contexts/IngredientUnitContext";
import { LoadingComponent } from "../LoadingComponent";
import { EmptyState } from "../EmptyStateComponent";
import { ConfirmActionModal } from "../modals/ConfirmActionModal";
import { IngredientUnitForm } from "./IngredientUnitForm";
import { IngredientUnitsList } from "./IngredientUnitsList";

export function IngredientUnitsSection() {
  const { ingredientUnits, loading, addIngredientUnit, removeIngredientUnit } =
    useIngredientUnits();
  const [unitToDelete, setUnitToDelete] = useState(null);

  const handleConfirmDelete = () => {
    removeIngredientUnit(unitToDelete);
    setUnitToDelete(null);
  };

  if (loading) {
    return (
      <LoadingComponent message="Loading your ingredient units..." compact />
    );
  }

  return (
    <div className="max-w-2xl">
      <h2 className="text-lg font-semibold text-gray-900">
        Ingredient Units
      </h2>
      <p className="text-sm text-gray-500 mt-1 mb-6">
        Manage the units you can use when adding ingredients, like "g", "cups"
        or "tbsp".
      </p>

      <IngredientUnitForm onAdd={addIngredientUnit} existingUnits={ingredientUnits} />

      {ingredientUnits.length === 0 ? (
        <EmptyState
          icon={Ruler}
          title="No units yet"
          description="Create your first ingredient unit to start using it in your recipes."
        />
      ) : (
        <IngredientUnitsList
          ingredientUnits={ingredientUnits}
          onDelete={setUnitToDelete}
        />
      )}

      {unitToDelete && (
        <ConfirmActionModal
          action={handleConfirmDelete}
          closeModal={() => setUnitToDelete(null)}
          heading="Delete this unit?"
          message="If this unit is currently used by an ingredient, it cannot be deleted."
          confirmButtonText="Delete Unit"
        />
      )}
    </div>
  );
}
